// Brazilian phone WhatsApp helpers
export function digitsOnly(s) {
  return (s || "").replace(/\D/g, "");
}

export function toWaNumber(phone) {
  let d = digitsOnly(phone);
  if (!d) return "";
  if (d.length === 10 || d.length === 11) d = "55" + d; // BR default
  return d;
}

export function buildWaUrl(phone, message) {
  const num = toWaNumber(phone);
  if (!num) return "";
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
}

export function checkinMessage(passenger, emission) {
  const dt = emission.departure_at ? new Date(emission.departure_at) : null;
  const dtStr = dt ? dt.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "";
  return (
    `Olá, ${passenger.full_name?.split(" ")[0] || ""}! ✈️\n\n` +
    `Lembrete da Letfly: seu voo está chegando!\n\n` +
    `🛫 ${emission.origin} → ${emission.destination}\n` +
    `🗓️ Partida: ${dtStr}\n` +
    `🏷️ Companhia: ${emission.airline}\n` +
    `🔖 Localizador: ${emission.pnr}\n` +
    (emission.flight_number ? `🔢 Voo: ${emission.flight_number}\n` : "") +
    `\nNão esqueça de fazer o check-in online com até 48h de antecedência. Boa viagem! 🌍`
  );
}

export function birthdayMessage(client) {
  return (
    `Olá, ${client.full_name?.split(" ")[0] || ""}! 🎂🎉\n\n` +
    `A Letfly deseja um feliz aniversário a você!\n` +
    `Que esse novo ciclo traga muitas viagens e realizações. ✈️🌍\n\n` +
    `Com carinho,\nEquipe Letfly`
  );
}

export function genericMessage(client) {
  return `Olá, ${client.full_name?.split(" ")[0] || ""}! Aqui é da Letfly. ✈️`;
}
